module.exports = __webpack_public_path__ + "img/Florias.bb63f155.jpeg";